// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'
import { string } from 'yup';

const obj = {
  field: [
    {
      title: "Location to block",
      attr: "content",
      value: "",
      id: "blocklocation",
      placeholder: "Specify the location to block to generate href tag",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Location to block is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Location to crawl",
      attr: "content",
      value: "",
      id: "crawllocation",
      placeholder: "Specify the location to block to generate href tag",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Location to crawl is Required"),
      // max: 100,

      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],
  example: [
    {
      title: "Location to block",
      attr: "content",
      value: "Result",
      id: "blocklocation",
      placeholder: "Specify the location to block to generate href tag",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Location to block is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Location to crawl",
      attr: "content",
      value: "of everything else",
      id: "crawllocation",
      placeholder: "Specify the location to block to generate href tag",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Location to crawl is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  editor: {
    output: `
User-agent: * 
Disallow: /result/ 
Allow: /
    `,
  },
};

export default obj;
